var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.room)?_c('div',{staticClass:"share-link-component"},[_c('span',{staticClass:"md-body-1"},[_vm._v("Share this link to let others to join: ")]),_c('span',{staticClass:"md-caption"},[_vm._v(_vm._s(_vm.shareLink))])]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }